import path from "node:path";
import express from "express";
import cors from "cors";
import { toNodeHandler } from "better-auth/node";
import { auth } from "./auth/index";
import { env } from "./lib/env";
import { rbacRouter } from "./modules/rbac/router";
import { employeesRouter } from "./modules/employees/router";
import { dashboardRouter } from "./modules/dashboard/router";
import { orgRouter } from "./modules/org/router";
import { hrRouter } from "./modules/hr/router";
import { letterRouter } from "./modules/letter/router";
import { attendanceRouter } from "./modules/attendance/router";
import { leaveRouter } from "./modules/leave/router";

const app = express();

app.use(
  cors({
    origin: env.FRONTEND_ORIGIN.split(",").map((o) => o.trim()),
    credentials: true,
  }),
);

// Better Auth must be mounted BEFORE express.json() — its handler needs the raw body,
// and Express 5 requires the named catch-all syntax `{*any}` (path-to-regexp v8).
app.all("/api/auth/{*any}", toNodeHandler(auth));

// JSON body parsing for all OTHER routes (feature APIs added during Step 3).
app.use(express.json());

app.get("/api/health", (_req, res) => {
  res.json({ status: "ok", service: "todays-work-backend" });
});

// Feature APIs (gated, company-scoped). B1: RBAC · B2: Employees.
app.use("/api", rbacRouter);
app.use("/api", employeesRouter);
app.use("/api", dashboardRouter);
app.use("/api", orgRouter);
app.use("/api", hrRouter);
app.use("/api", letterRouter);
app.use("/api", attendanceRouter);
app.use("/api", leaveRouter);

// Production (cPanel): ONE Node app serves the built SPA + assets from the same origin as /api,
// so Better Auth session cookies are first-party and no CORS/cross-subdomain config is needed.
// In dev this block is skipped — Vite serves the frontend and proxies /api here.
if (process.env.NODE_ENV === "production") {
  app.set("trust proxy", true); // behind LiteSpeed/Passenger — trust X-Forwarded-* for secure cookies
  // Resolve to absolute — res.sendFile requires an absolute path (relative STATIC_DIR would 500).
  const staticDir = path.resolve(process.env.STATIC_DIR || path.join(process.cwd(), "public"));
  app.use(express.static(staticDir));
  // SPA fallback: any non-API GET returns index.html so client-side routes deep-link correctly.
  app.use((req, res, next) => {
    if (req.method === "GET" && !req.path.startsWith("/api")) {
      return res.sendFile(path.join(staticDir, "index.html"));
    }
    next();
  });
}

// Express 5 forwards rejected promises to error middleware automatically.
app.use((err: unknown, _req: express.Request, res: express.Response, _next: express.NextFunction) => {
  console.error(err);
  res.status(500).json({ error: "Internal Server Error" });
});

app.listen(env.PORT, () => {
  console.log(`▶ backend listening on http://localhost:${env.PORT}`);
});
